import { render, staticRenderFns } from "./TemplateItemTitle.vue?vue&type=template&id=0177c96e"
import script from "./TemplateItemTitle.vue?vue&type=script&lang=js"
export * from "./TemplateItemTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports